import React from 'react';

const VideoDetail = ({ video }) => {
	if (!video) {
		return<div>Loading...</div>;
	}

	const videoId = video.id.videoId;
	const url = `https://www.youtube.com/embed/${videoId}`;

	return (
		<div className="video-detail col-md-7">
			<div className="embed-responsive embed-responsive-16by9">
				<iframe className="embed-responsive-item" src={url}></iframe>
			</div>
			<div className="details">
				<div id="video-title">{video.snippet.title}</div>
				
			</div>
		</div>
	);
};

// <div id="video-desc">{video.snippet.description}</div>

export default VideoDetail;


// WEBPACK FOOTER //
// ./src/components/video_detail.js